import { Component, OnInit } from '@angular/core';
import {
  Router,
  Event,
  ActivationEnd,
  NavigationEnd,
  ActivatedRoute
} from "@angular/router";
import { Subscription } from 'rxjs';
import { filter, buffer } from "rxjs/operators";
import { AdvertiserService } from 'src/app/core/services/advertiser.service';
import { PermissionService } from 'src/app/core/services/permisson.service';
import { UserService } from 'src/app/core/services/user.service';
import {
  SUB_PATH,
  NON_API_ADV_ROLES,
  AGN_ADV_LVL_ROLES,
  AGN_LVL_ROLES,
} from 'src/app/models/common';
import { getRoleAndDefaultPageMapping } from '../../utils/commonUtils';

/**
 * Check if an angular router 'Event' is instance of 'NavigationEnd' event
 */
const isNavigationEnd = (ev: Event) => ev instanceof NavigationEnd;
/**
 * Check if an angular router 'Event' is instance of 'NavigationEnd' event
 */
const isActivationEnd = (ev: Event) => ev instanceof ActivationEnd;

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  bcLoadedData: Array<any> = [];
  role: string;
  role_default;
  roleParam = {}
  edit_id;
  edit_name: string = '';
  advertiserName: string;
  agencyAdvertiserName: string;
  agencyName: string;
  ioName: string;
  liName: string;
  edit_permission: boolean;
  isCLientPolitical:boolean;
  show_segment_type:boolean;
  subscribe: Subscription;
  isCampaign: boolean = false;
  adsp_enabled: boolean = false;
  tdsp_enabled: boolean = false;
  apnx_enabled: boolean = false;
  bdsp_enabled: boolean = false;
  sub_path = SUB_PATH;
  adv_tier: string;
  redirectPath;

  create: string;
  plReportName: string = "p & l report";
  edit: string;

  ioIdAsParams: string[] = [];

  breadcrumbsName = {
    "account-manager": 'Account Managers',
    "platform-admin": "Platform Admins",
    "insertion-order": 'Insertion Orders',
    "conversion-pixel": 'Conversion Pixels',
    "contract": 'Contract',
    "line item": 'Line Items',
    'campaign': 'Campaigns',
    'POLITICAL ADVERTISER':'POLITICAL ADVERTISERS',
    'AGENCY ADVERTISER':'AGENCY ADVERTISERS',
    "creatives": 'Creatives',
    "creative": "Creatives",
    "agency": 'Agencies',
    "advertiser": 'Advertisers',
    "segments": 'Segments',
    "segment-pixel": 'Segments',
    "audience": 'Audiences',
    'Audience':'Audience',
    "inventory": 'Inventory Lists',
    'Domain App Lists':'Domain App Lists',
    "account": 'Accounts',
    "report": 'Reports',
    "analytics": 'Analytics',
    "profile": 'Profile',
    "platform-notification": 'Platform Notification',
    "event": 'Events',
    "conversion-tracker": 'Conversion Trackers',
    "deals": 'Deals',
    "custom-location": 'Custom Locations',
    "account-statement": 'My Account',
    'user': 'Users',
    'agency-advertiser': 'Agency Advertisers',
    'create': 'Create',
    'bulk-edit': 'Bulk Edit',
    'status-update': 'Payment Status',
    'coupon-code': 'Coupon Codes',
    'store': 'Stores',
    'custom-list': 'Custom Lists',
    'delivery-modifier': 'Delivery Modifiers'
  }

  permission_name_mapping = {
    "account-manager": 'account_manager',
    "platform-admin": 'platform_admin',
    "insertion-order": 'insertion_order',
    "conversion-pixel": 'pixel',
    "campaign": 'line_item',
    "adsp/insertion-order": 'insertion_order',
    "adsp/campaign": 'line_item',
    "adsp/creative": 'creative',
    "adsp/conversion-tracker": 'pixel',
    "adsp/agency-advertiser": 'agency_advertiser',
    "creatives": 'creative',
    "agency": 'agency',
    "advertiser": 'advertiser',
    "report": 'report',
    "adsp/report": 'report',
    "deals": 'deal',
    'agency_user': 'agency_user',
    'advertiser_user': 'advertiser_user',
    'agency-advertiser': 'agency_advertiser',
    'contract': 'msa_contract',
    'coupon-code': 'coupon_code',
    'store': 'store',
    "bdsp/insertion-order": 'insertion_order',
    "bdsp/campaign": 'line_item',
    "bdsp/creative": 'creative',
    "bdsp/agency-advertiser": 'agency_advertiser',
    "bdsp/event": 'pixel',
    "bdsp/report" : 'report',
    "bdsp/delivery-modifier": 'delivery_modifier',
    "tdsp/agency-advertiser": 'agency_advertiser',
    "tdsp/segments":["advertiser_segment","agadv_segment"]
  }

  levelBasedEditPermission = [
    "segment-pixel",
    "inventory",
    "custom-location",
    "adsp/inventory",
    "bdsp/segment-pixel",
    "bdsp/custom-list",
  ];

  adspRegion: string;

  constructor(
    private router: Router,
    private permissionService: PermissionService,
    public advertiserService: AdvertiserService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.ioIdAsParams = [
      "insertion_order_id",
      "adsp_insertion_order_id",
      "bdsp_insertion_order_id",
      "tdsp_insertion_order_id",
    ];
    this.role = localStorage.getItem('role')
    let advertiser_id = localStorage.getItem('advertiser_id')
    let agency_id = localStorage.getItem('agency_id')
    let agency_advertiser_id = localStorage.getItem('agency_advertiser_id')

    const {redirectPath, params} = getRoleAndDefaultPageMapping(this.role)
    this.redirectPath = redirectPath;
    this.roleParam = { ...this.roleParam, ...params};

    if (NON_API_ADV_ROLES.has(this.role)) {
      this.roleParam['advertiser_id'] = advertiser_id
    }
    else if (AGN_LVL_ROLES.has(this.role)) {
      this.roleParam['agency_id'] = agency_id
    }
    else if (AGN_ADV_LVL_ROLES.has(this.role)) {
      this.roleParam['agency_advertiser_id'] = agency_advertiser_id
    }
    this.routerBreadcrumbs()
  }

  checkEditPermission(component) {
    const components = Array.isArray(component) ? component : [component];

    this.edit_permission = components.some((c) =>
      this.permissionService.getEditPermissions(c)
    );

    this.bcLoadedData.forEach((data)=>{
      if(data['path'].includes("adsp/deals") &&( data['params']['advertiser_id'] || data['params']['agency_advertiser_id'] || data['params']['agency_id']) ){
        this.edit_permission = false;
      }
      else if(data['path'].includes("coupon-code")){
        this.edit_permission = false;
      }
    })

  }

  routerBreadcrumbs() {

    /**
     * navigationEnd$ is trigered once per completed routing event, in other words
     * once per loading a component that is in the end of the current route
     */

    /**
     * Here we subscribe to all navigation events, in order to update
     * our route "data", which we will use for the breadcrumb visualization.
     *
     * Than we filter the events emitted from the `router` in such way, that we are only
     * taking action upon a completed router event (in other words we are subscribing only for `ActivationEnd`
     * events)
     *
     * We use pluck to get only the requried bredcrumb data
     *
     * The buffer operator accumulates all `data` coming from the router and emmits the accumulated data once
     * when a `NavigationEnd` event passes troufh `navigationEnd$`
     *
     * The `map` in the end is used to reverse the collected data, in order to convert it to more logical
     * sequence. Without the revers first we will get the data for the current route, after that for it's parent
     * and so on (that is how the ng router works).
     */
    const navigationEnd$ = this.router.events.pipe(filter(isNavigationEnd));
    this.populateBreadcrumbs()
    let agency_id = localStorage.getItem('agency_id');
    let advertiser_id = localStorage.getItem('advertiser_id');
    if(agency_id){
      this.permissionService.getConfig(agency_id,'agency').subscribe(res => {
        this.isCLientPolitical = res.data.vertical == 'political' ? true :false;
        this.adsp_enabled = res.data.adsp_enabled;
        this.bdsp_enabled = res.data.bdsp_enabled;
        this.apnx_enabled = res.data.apnx_enabled;
        this.tdsp_enabled = res.data.tdsp_enabled;
        this.populateBreadcrumbs()
        })
    } else if(advertiser_id) {
      this.permissionService.getConfig(advertiser_id,'advertiser').subscribe(res => {
        this.adsp_enabled = res.data.adsp_enabled;
        this.bdsp_enabled = res.data.bdsp_enabled;
        this.tdsp_enabled = this.tdsp_enabled;
        this.adv_tier = res.data.tier;
        this.apnx_enabled = res.data.apnx_enabled;
        this.populateBreadcrumbs()
        })
    }

    this.subscribe = this.router.events
      .pipe(
        filter(isActivationEnd),
        buffer(navigationEnd$),
        // pluck("snapshot"),
        // pluck("data"),
        // map((bcData: any[]) => bcData.reverse())
      )
      .subscribe(x => {
      let params = this.activatedRoute.snapshot.queryParamMap['params']
      this.userService.getClientSettingData(params).subscribe((res)=>{
        this.isCampaign = res.data.campaign.view;
        this.populateBreadcrumbs()
      })
      }, (err) => {
        // console.log('error>>>>>>>>>>>', err)
      });
  }

  getAdspRegion(params) {
      return params["adsp_region"]
      ? params["adsp_region"]
      : localStorage.getItem("adsp_us_region") == "true"
      ? "US"
      : localStorage.getItem("adsp_uk_region") == "true"
      ? "EU"
      : ""
  }


  /**
   * @description if user is at non dsp pages (my-accounts, user, etc..)
   * assigns breadcrumb uri to first part of breacrumb
   *
   * @params role based default page uri
   *
   * @returns string
   */

  getFirstBreadCrumbUri(type: string): string {
    if (this.adv_tier === 'lite' && type === 'insertion-order') {
      return 'campaign';
    }

    const { tdsp_enabled, bdsp_enabled, adsp_enabled, apnx_enabled } = this;

    if (tdsp_enabled && !bdsp_enabled && !adsp_enabled && !apnx_enabled) {
      return `tdsp/${type}`;
    }

    if (bdsp_enabled && !adsp_enabled && !apnx_enabled) {
      return `bdsp/${type}`;
    }

    if (adsp_enabled && !apnx_enabled) {
      return `adsp/${type}`;
    }

    return type;
}


  /**
   * @description returns breadcrumb entity name for non apnx dsps
   *
   * @params dsp type and entity uri
   *
   * @returns string
   */

  getNonVDSPEntityName(dsp, name) {
    if (name == 'campaign') {
      return 'line item';
    } else if (name == 'segment-pixel') {
      return  dsp == 'adsp'? 'audience': 'segments';
    } else  {
      return name
    }
  }


  /**
   * @description returns breadcrumb entity name for apnx dsp
   *
   * @params entity uri
   *
   * @returns string
   */

  getVDSPEntityName(name) {
    if (name == 'campaign') {
      return this.isCampaign ? 'campaign' : 'line item';
    } else if (name == 'agency_advertiser') {
      return this.isCLientPolitical ? 'POLITICAL ADVERTISER' : 'AGENCY ADVERTISER';
    } else if (name == 'segment-pixel') {
      return 'segments';
    } else  {
      return name
    }
  }

  checkForPLReport() {
    if (
      this.bcLoadedData[0].bc_name == "report" &&
      this.bcLoadedData[0].params["advertiser_id"] == undefined &&
      this.bcLoadedData[0].params["agency_id"] == undefined &&
      this.bcLoadedData[0].params["agency_advertiser_id"] == undefined
    ) {
      this.bcLoadedData[0].bc_name = this.plReportName;
    }
  }

  populateNameAndUrl() {
    let params = this.activatedRoute.snapshot.queryParamMap['params']
    this.advertiserName = localStorage.getItem('advertiser_name') || 'advertiser'
    this.agencyAdvertiserName = localStorage.getItem('agency_advertiser_name') || 'agency_advertiser'
    this.ioName = localStorage.getItem('insertion_order_name') || 'insertion order'
    this.liName = localStorage.getItem('line_item_name') || 'line item'
    this.agencyName = localStorage.getItem('agency_name') || 'agency'
    this.bcLoadedData = []
    let redirectParam = {}

    let uriFirstIndex = this.router.url.split('?')[0].split('/')[1];
    let uriSecondIndex = this.router.url.split('?')[0].split('/')[2];
    let uriThirdIndex = this.router.url.split('?')[0].split('/')[3];
    let uriFourIndex = this.router.url.split('?')[0].split('/')[4];

    if ('agency_id' in params || 'agency_advertiser_id' in params) {
      redirectParam = {
        agency_id: localStorage.getItem("agency_id")
      };
      let path;
      if(this.sub_path.includes(uriFirstIndex)) {
        path = `${uriFirstIndex}/agency-advertiser`
        if(uriFirstIndex == 'adsp') {
          redirectParam['adsp_region'] = this.getAdspRegion(params)
        }
      } else {
        path = this.getFirstBreadCrumbUri('agency-advertiser')
      }
      this.bcLoadedData.push({
        'bc_name': `AGC: ${this.agencyName}`,
        'path': path,
        'params': redirectParam
      })
    }
    if ('advertiser_id' in params) {
      redirectParam = {
        advertiser_id: params['advertiser_id']
      };
      let path;
      if(this.sub_path.includes(uriFirstIndex)) {
        path = `${uriFirstIndex}/insertion-order`
        if(uriFirstIndex == 'adsp') {
          redirectParam['adsp_region'] = this.getAdspRegion(params);
        }
      }  else {
        path = this.getFirstBreadCrumbUri('insertion-order');
      }
      this.bcLoadedData.push({
        'bc_name': `ADV: ${this.advertiserName}`,
        'path': path,
        'params': redirectParam
      })
    }
    if ('agency_advertiser_id' in params && this.role != 'agency_reporting_user') {
      redirectParam = { agency_advertiser_id: params['agency_advertiser_id'],
        adsp_region: params['adsp_region']
    }
      let path;
      if(this.sub_path.includes(uriFirstIndex)) {
        path = `${uriFirstIndex}/insertion-order`
      } else {
        path = this.getFirstBreadCrumbUri('insertion-order');
      }
      this.bcLoadedData.push({
        'bc_name': `AGC ADV: ${this.agencyAdvertiserName}`,
        'path': path,
        'params': redirectParam
      })
    }
    if ('agency_advertiser_id' in params && this.role == 'agency_reporting_user') {
      redirectParam = { agency_advertiser_id: params['agency_advertiser_id'],
        adsp_region: params['adsp_region']
    }
      let path;
      if(this.sub_path.includes(uriFirstIndex)) {
        path = `${uriFirstIndex}/report`
      }
      else {
        path = this.getFirstBreadCrumbUri('insertion-order');
      }
      this.bcLoadedData.push({
        'bc_name': `AGC ADV: ${this.agencyAdvertiserName}`,
        'path': path,
        'params': redirectParam
      })
    }

    /** To populate breacrumb in Campaign page, if user navigates to LI
     * page from IO page by applying IO ID filter
     */

    this.ioIdAsParams.forEach((ioId) => {
      let dsp = ioId.split('_insertion_order_id')[0]
      if(ioId in params) {
        redirectParam = {
          advertiser_id: params['advertiser_id'],
          agency_advertiser_id: params['agency_advertiser_id']
        }
        redirectParam[ioId] = params[ioId];
        dsp == 'adsp' ? redirectParam['adsp_region'] = params['adsp_region']: '';
        this.bcLoadedData.push({
          'bc_name': `IO: ${this.ioName} (${params[ioId]})`,
          'path': this.sub_path.includes(dsp) ? `${dsp}/insertion-order` : '/insertion-order',
          'params': redirectParam
        })
      }
    })


    /** To populate breacrumb in Creative page, if user navigates to Creative
     * page from LI page by applying LI ID filter
     */

    if ('line_item_id' in params) {
      redirectParam = {
        advertiser_id: params['advertiser_id'],
        agency_advertiser_id: params['agency_advertiser_id'],
        line_item_id: params['line_item_id'],
      }
      uriFirstIndex == 'adsp' ? redirectParam['adsp_region'] = params['adsp_region']: '';
      this.bcLoadedData.push({
        'bc_name': `LI: ${this.liName} (${params['line_item_id']})`,
        'path': this.sub_path.includes(uriFirstIndex) ? `${uriFirstIndex}/campaign` : '/campaign',
        'params': redirectParam
      })
    }
    if(this.sub_path.includes(uriFirstIndex)) {
      this.bcLoadedData.push({
        'bc_name': this.getNonVDSPEntityName(uriFirstIndex, uriSecondIndex),
        'path': `${uriFirstIndex}/` + uriSecondIndex,
        'params': {
          advertiser_id: params['advertiser_id'],
          agency_id: params['agency_id'],
          agency_advertiser_id: params['agency_advertiser_id'],
          adsp_region: params['adsp_region']
        }
      })
      this.checkForPLReport();
    }
    else {
      this.bcLoadedData.push({
        'bc_name': this.getVDSPEntityName(uriFirstIndex),
        'path': uriFirstIndex,
        'params': {
          advertiser_id: params['advertiser_id'],
          agency_id: params['agency_id'],
          agency_advertiser_id: params['agency_advertiser_id'],
          adsp_region: params['adsp_region']
        }
      })
      this.checkForPLReport();
    }

    if(this.sub_path.includes(uriFirstIndex)) {
      this.create = uriThirdIndex
      this.edit_id = uriThirdIndex
      this.edit = uriFourIndex
    } else {
      this.create = uriSecondIndex
      this.edit_id = uriSecondIndex
      this.edit = uriThirdIndex
    }
    if (this.create && this.create == 'create') {
      this.bcLoadedData.push({
        'bc_name': 'create',
        'path': this.router.url.split('?')[0],
        'params': {
          advertiser_id: params['advertiser_id'],
          agency_id: params['agency_id'],
          agency_advertiser_id: params['agency_advertiser_id'],
          adsp_region: params['adsp_region']
        }
      })
    }
    if (this.create && this.create == 'bulk-edit') {
      this.bcLoadedData.push({
        'bc_name': 'bulk-edit',
        'path': this.router.url.split('?')[0],
        'params': {
          advertiser_id: params['advertiser_id'],
          agency_id: params['agency_id'],
          agency_advertiser_id: params['agency_advertiser_id'],
          adsp_region: params['adsp_region']
        }
      })
    }
    if (this.edit && this.edit == 'edit') {
      this.edit_name = localStorage.getItem('edit_name') || '';
      let route_name = this.sub_path.includes(uriFirstIndex) ? `${uriFirstIndex}`+'/'+this.router.url.split('/')[2] : this.router.url.split('/')[1]
      if (window.history.state.edit_permission !=null && this.levelBasedEditPermission.includes(route_name)) {
        localStorage.setItem('edit_permission_' + route_name, window.history.state.edit_permission)
      }
      if (route_name == 'user') {
        route_name = this.activatedRoute.snapshot.queryParamMap.get("agency_id") ? 'agency_user' : 'advertiser_user'
      }
      if (this.levelBasedEditPermission.includes(route_name)) {
        this.edit_permission = localStorage.getItem('edit_permission_' + route_name) == 'true'
      } else {
        this.checkEditPermission(this.permission_name_mapping[route_name])
      }
      this.bcLoadedData.push({
        'bc_name': `edit`,
        'path': this.router.url.split('?')[0],
        'params': {
          advertiser_id: params['advertiser_id'],
          agency_id: params['agency_id'],
          agency_advertiser_id: params['agency_advertiser_id'],
          adsp_region: params['adsp_region']
        }
      })
    }
  }

  populateBreadcrumbs() {
    if (window.history.state.advertiser_name) {
      localStorage.setItem('advertiser_name', window.history.state.advertiser_name)
    }
    if (window.history.state.agency_advertiser_name) {
      localStorage.setItem('agency_advertiser_name', window.history.state.agency_advertiser_name)
    }
    if (window.history.state.insertion_order_name) {
      localStorage.setItem('insertion_order_name', window.history.state.insertion_order_name)
    }
    if (window.history.state.agency_name) {
      localStorage.setItem('agency_name', window.history.state.agency_name)
    }
    if (window.history.state.edit_name) {
      localStorage.setItem('edit_name', window.history.state.edit_name)
    }
    if((this.role == 'platform_superadmin' || this.role == 'platform_admin' ||
        this.role == 'account_manager' || this.role == 'platform_account_user')
      )
    {
      let client_id, service;
      let agency_id = this.activatedRoute.snapshot.queryParamMap.get('agency_id');
      let advertiser_id = this.activatedRoute.snapshot.queryParamMap.get('advertiser_id');
      if(advertiser_id) {
        client_id = advertiser_id;
        service = 'advertiser';
      } else if(agency_id) {
        client_id = agency_id;
        service = 'agency';
      }
      if(advertiser_id || agency_id) {
        this.permissionService.getConfig(client_id, service).subscribe(res => {
          this.adsp_enabled = res.data.adsp_enabled;
          this.bdsp_enabled = res.data.bdsp_enabled;
          this.tdsp_enabled = res.data.tdsp_enabled;
          this.adv_tier = res.data.tier;
          this.apnx_enabled = res.data.apnx_enabled;
        }, () => {}, () => {
          this.populateNameAndUrl();
        })
      } else {
        this.populateNameAndUrl();
      }
    } else {
      this.populateNameAndUrl();
    }
  }

  ngOnDestroy(){
    this.subscribe.unsubscribe();
  }
}

